const COLUMNS_CONTAINER_COMPONENT_TYPE = 'wysiwyg.viewer.components.StripColumnsContainer'

export const columnMetadata = {
    isContainCheckRecursive: false,
    enforceContainerChildLimitsByWidth: false,
    enforceContainerChildLimitsByHeight: true,
    allowedParentTypes: [COLUMNS_CONTAINER_COMPONENT_TYPE]
}
